( function( app ) {
  const COMPONENT = {
    init: function() {
      const primaryNavLinks = document.querySelectorAll( '.navigation-one a[href$="#primary-nav"]' );
      const toggleBtn = document.querySelector( '.navigation-one .navbar-toggle' );
      const desktopQuery = window.matchMedia( '(min-width: 1024px)' );
      const primaryNav = document.querySelector( '.navigation-one #primary-nav' );
      const panels = document.querySelector( '.navigation-one .primary-navigation__panels' );
      let equalizePanelsFrame;

      const syncPrimaryNavLinks = () => {
        if ( !toggleBtn ) return;

        primaryNavLinks.forEach( ( link ) => {
          link.classList.toggle( 'is-open', toggleBtn.classList.contains( 'is-open' ) );
        } );
      };

      const equalizeDesktopPanelHeights = () => {
        if ( !panels ) return;

        const directColumns = Array.from( panels.children ).filter( ( child ) => {
          return child.matches( 'div, ul' );
        } );
        const openGrandchildColumns = Array.from( panels.querySelectorAll( '[id^="child-menu-"].is-open' ) );
        const columns = directColumns.concat( openGrandchildColumns );

        panels.style.removeProperty( 'min-height' );
        columns.forEach( ( column ) => column.style.removeProperty( 'min-height' ) );

        if ( !desktopQuery.matches ) return;

        const navStyles = primaryNav ? window.getComputedStyle( primaryNav ) : null;
        const navPadding = navStyles ?
          parseFloat( navStyles.paddingTop ) + parseFloat( navStyles.paddingBottom ) :
          0;
        const availableHeight = primaryNav ? primaryNav.clientHeight - navPadding : panels.clientHeight;
        const maxHeight = Math.max(
            availableHeight,
            ...columns.map( ( column ) => column.scrollHeight ),
        );

        panels.style.minHeight = `${ maxHeight }px`;
        directColumns.forEach( ( column ) => {
          column.style.minHeight = `${ maxHeight }px`;
        } );
      };

      const queueEqualizeDesktopPanelHeights = () => {
        window.cancelAnimationFrame( equalizePanelsFrame );
        equalizePanelsFrame = window.requestAnimationFrame( equalizeDesktopPanelHeights );
      };

      $( toggleBtn ).on( 'toggleAfter', () => {
        syncPrimaryNavLinks();
        queueEqualizeDesktopPanelHeights();
      } );

      document.addEventListener( 'click', ( e ) => {
        const link = e.target.closest( '.navigation-one a[href$="#primary-nav"]' );
        if ( !link || !toggleBtn ) return;

        e.preventDefault();
        toggleBtn.click();
      } );

      syncPrimaryNavLinks();
      queueEqualizeDesktopPanelHeights();

      $( '.navigation-one .primary-child-menu-item__link[data-toggle-target]' ).on( 'toggleBefore', function() {
        if ( desktopQuery.matches ) return;

        const target = this.getAttribute( 'data-toggle-target' );
        if ( !target ) return;

        const $target = $( target );
        if ( !$target.length ) return;

        $target.stop( true, true );

        if ( $target.hasClass( 'is-open' ) ) {
          $target.slideUp();
        } else {
          $target.hide().slideDown();
        }
      } );

      const clearMobileSubmenuStyles = () => {
        if ( !desktopQuery.matches ) return;

        $( '.navigation-one [id^="child-menu-"]' ).stop( true, true ).removeAttr( 'style' );
        queueEqualizeDesktopPanelHeights();
      };

      if ( desktopQuery.addEventListener ) {
        desktopQuery.addEventListener( 'change', () => {
          clearMobileSubmenuStyles();
          queueEqualizeDesktopPanelHeights();
        } );
      } else {
        desktopQuery.addListener( () => {
          clearMobileSubmenuStyles();
          queueEqualizeDesktopPanelHeights();
        } );
      }

      $( '.navigation-one .primary-menu-item__link[data-toggle-target], .navigation-one .primary-child-menu-item__link[data-toggle-target]' ).on( 'toggleAfter', queueEqualizeDesktopPanelHeights );
      window.addEventListener( 'resize', queueEqualizeDesktopPanelHeights );

      if ( $( window ).width() <= 1024 ) return;

      // ADA close menu when focus shifts outside of it
      $( '.navigation-one .primary-navigation__panels' ).on( 'focusout', function( e ) {
        const $menuItem = $( this );
        const newFocus = e.relatedTarget;
        if ( newFocus === null ) return;
        if ( !$menuItem.has( newFocus ).length ) {
          const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
          if ( $trigger.length ) {
            $trigger.trigger( 'click' );
            newFocus.focus();
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-one', COMPONENT );
} )( app );
